import type { Dispatch, FC, SetStateAction } from 'react';
import React, { useEffect } from 'react';

import { useAutomationMenu } from '../common/ConfluenceManualRulesContainer';
import { Skeleton } from '../common/Skeleton';

import { AutomationModalRuleList } from './AutomationModalRuleList';
import { AutomationModalErrorState } from './AutomationModalErrorState';

type AutomationModalBodyProps = {
	selectedRuleId: number | undefined;
	setSelectedRuleId: Dispatch<SetStateAction<number | undefined>>;
};

export const AutomationModalBody: FC<AutomationModalBodyProps> = ({
	selectedRuleId,
	setSelectedRuleId,
}) => {
	const { triggerFetch, initialised, rules, error, aris } = useAutomationMenu();

	useEffect(() => {
		void triggerFetch();
		// Want to ensure that triggerFetch is only called once when the component is mounted.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (aris.length === 0) {
		return <Skeleton lineCount={10} />;
	}

	if (!initialised) {
		return <Skeleton lineCount={10} />;
	} else if (error && rules.length === 0) {
		return <AutomationModalErrorState />;
	}

	return (
		<AutomationModalRuleList
			selectedRuleId={selectedRuleId}
			setSelectedRuleId={setSelectedRuleId}
		/>
	);
};
